export function getCanonicalThreadPath(
  orgSlug: string,
  routeId: string
): string {
  return `/${encodeURIComponent(orgSlug)}/threads/${encodeURIComponent(routeId)}`;
}

export function getOrgDesignPath(orgSlug: string): string {
  return `/${encodeURIComponent(orgSlug)}/design`;
}

export function getOrgSettingsPurchasePath(orgSlug: string): string {
  return `/${encodeURIComponent(orgSlug)}/settings/purchase`;
}

export function shouldReplaceCanonicalThreadUrl(
  currentRouteRef: string,
  canonicalRouteId: string
): boolean {
  return canonicalRouteId.length > 0 && canonicalRouteId !== currentRouteRef;
}

export function getCanonicalThreadHref(
  pathname: string,
  search: string,
  hash: string
): string {
  return `${pathname}${search}${hash}`;
}

export function replaceCanonicalThreadUrl(pathname: string): void {
  if (typeof window === 'undefined') return;
  const nextHref = getCanonicalThreadHref(
    pathname,
    window.location.search,
    window.location.hash
  );
  const currentHref = getCanonicalThreadHref(
    window.location.pathname,
    window.location.search,
    window.location.hash
  );
  if (currentHref === nextHref) return;
  // history.replaceState updates the address bar without informing the Next
  // App Router tree. `useParams().id` and the layout's server `params.id`
  // therefore keep the alias until a real navigation. That is the intended
  // tradeoff: a router.replace would remount `loading.tsx` over the message
  // column during canonicalization.
  window.history.replaceState(window.history.state, '', nextHref);
}
